// extracted by mini-css-extract-plugin
module.exports = {"list":"Nav_list__3e5VO"};